export const UPLOAD_STAGES = {
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  AWAITING_PASSWORD: 'awaiting-password',
  COMPLETED: 'completed',
  FAILED: 'failed',
  AWAITING_REMOVED: 'awaiting-removed', // TODO: Handle DELETED instead of removing files immediately
}

export const PASSWORD_STATUSES = {
  REQUIRED: 'required',
  VERIFYING: 'verifying',
  INCORRECT: 'incorrect',
  VERIFIED: 'verified',
}

export const POLLING_CONFIG = {
  INTERVAL: 5000, // 5 seconds
  REQUEST_TIMEOUT: 15 * 1000, // a hung status request fails and is retried instead of stalling the file
  MAX_DURATION: {
    PROCESSING: 60 * 1000, // 1 minutes
    METADATA: 60 * 1000, // 1 minutes
  },
}
